const RISK_ASSESSMENT_STORAGE_PREFIXES = [
  "risk_assessment_",
  "risk_assesment_",
];

export const clearRiskAssessmentStorage = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  const keysToRemove = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (
      key &&
      RISK_ASSESSMENT_STORAGE_PREFIXES.some((prefix) =>
        key.startsWith(prefix)
      )
    ) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};
